import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';

import { TXTMOB_Load_more, TXTWCL_Showing_N0_results_out_of_N1 } from './LoadMore.messages.json';
import styles from './LoadMore.scss';

export interface Props {
  len: number;
  count: number;
  loadMore: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const LoadMore: React.FC<Props> = ({ len, count, loadMore }) => (
  <div className={styles.loadMore}>
    <p className={styles.pageNumber}>
      <Translation values={{ 0: len, 1: count }} {...TXTWCL_Showing_N0_results_out_of_N1} />
    </p>
    {count > len && <StarsButton onClick={loadMore} translation={TXTMOB_Load_more} />}
  </div>
);

export default LoadMore;
